const initialState = {
  autoAssets: [],
};

export default initialState;
